<template>
  <b-modal
    v-model="visible"
    :busy="busy"
    scrollable
    title="Đề xuất ngừng theo dõi bệnh nhân"
    no-close-on-esc
    no-close-on-backdrop
    no-enforce-focus
    size="xxl"
    @ok="submit"
    @hidden="hide"
  >
    <div class="row">
      <div class="col-md">
        <form-select
          label="Lý do ngừng theo dõi"
          :model="formModel"
          attribute="stopFollowReason"
          :errors="formErrors"
          :options="OPTIONS_STOP_FOLLOW_REASON"
        ></form-select>
        <form-input
          label="Mô tả"
          :model="formModel"
          attribute="stopFollowReasonDetail"
          :errors="formErrors"
        ></form-input>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <b-alert show variant="warning">
          Khi xác nhận Đề xuất ngừng theo dõi, bạn đồng ý chịu trách nhiệm về việc xác thực thông tin này. Sau khi xác
          nhận, yêu cầu ngừng theo dõi bệnh nhân này sẽ được gửi cho Bác sĩ của bạn. Hãy liên hệ với Bác sĩ để được phê
          duyệt yêu cầu.
        </b-alert>
        <form-checkbox
          :model="formModel"
          :errors="formErrors"
          attribute="isConfirmed"
          :chk-label="`Xác nhận đề xuất ngừng theo dõi bệnh nhân dưới đây`"
        ></form-checkbox>
      </div>
    </div>
    <div v-if="benhNhan" class="row">
      <div class="col-md c-template-table table-responsive">
        <table class="table table-bordered table-more table-hover">
          <thead>
            <tr>
              <th class="th-number">#</th>
              <th>Bệnh nhân</th>
              <th class="text-center">Nhóm NC</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="th-number">1</td>
              <td>
                <p>
                  Tên BN: <b>{{ benhNhan.name ? benhNhan.name : $t('unknown') }}</b>
                </p>
                <p>
                  Năm sinh: <b>{{ benhNhan.dob ? benhNhan.dob : $t('unknown') }}</b>
                </p>
                <p>
                  Giới tính:
                  <b>{{ benhNhan.gender === 'male' ? 'Nam' : benhNhan.gender === 'female' ? 'Nữ' : 'Không rõ' }}</b>
                </p>
                <p v-if="benhNhan.stopFollowTime"><span class="badge badge-secondary">Đã ngừng theo dõi</span></p>
              </td>
              <td class="text-center">
                <p>
                  <span v-if="!benhNhan.tier" class="badge badge-secondary">Chưa cập nhật</span>
                  <span v-else-if="benhNhan.tier === 'nc0'" class="badge badge-success">NC0</span>
                  <span v-else-if="benhNhan.tier === 'nc1'" class="badge badge-info">NC1</span>
                  <span v-else-if="benhNhan.tier === 'nc2'" class="badge badge-primary">NC2</span>
                  <span v-else-if="benhNhan.tier === 'nc3'" class="badge badge-warning">NC3</span>
                  <span v-else class="badge badge-danger">NC4</span>
                </p>
                <br />
                <p v-if="benhNhan.nextTier && benhNhan.tier && benhNhan.nextTier !== benhNhan.tier">
                  <span class="badge badge-warning glow"
                    ><b-spinner type="grow" small></b-spinner> Cần duyệt chuyển {{ benhNhan.nextTier }}</span
                  >
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <template #modal-ok>
      <b-spinner v-if="busy" small variant="primary"></b-spinner>
      {{ $t('send') }}
    </template>
    <template #modal-cancel>
      {{ $t('cancel') }}
    </template>
  </b-modal>
</template>

<script>
import OPTIONS_STOP_FOLLOW_REASON from './constants/options-stop-follow-reason.json'

const DEFAULT_FORM_MODEL = {
  stopFollowReason: null,
  stopFollowReasonDetail: "",
  isConfirmed: false,
};

export default {
  inheritAttrs: false,
  created() {
    this.OPTIONS_STOP_FOLLOW_REASON = OPTIONS_STOP_FOLLOW_REASON;
  },
  data() {
    return {
      visible: false,
      busy: false,
      benhNhan: null,
      formModel: DEFAULT_FORM_MODEL,
      formErrors: [],
    };
  },  
  methods: {
    show(benhNhan) {
      this.benhNhan = benhNhan;
      this.formModel = { ...DEFAULT_FORM_MODEL };
      this.formErrors = [];
      this.visible = true;
    },
    hide() {
      this.benhNhan = null;
      this.formModel = { ...DEFAULT_FORM_MODEL };
      this.formErrors = [];
      this.visible = false;
    },
    validate() {
      this.formErrors = [];
      if (this.formModel.isConfirmed === false) {
        this.formErrors.push({
          msg: 'Vui lòng đánh dấu vào ô xác nhận',
          param: 'isConfirmed',
        });
      }
      if (this.formModel.stopFollowReason === null) {
        this.formErrors.push({
          msg: 'Vui lòng chọn lý do ngừng theo dõi',
          param: 'stopFollowReason',
        });
      }
    },
    async submit(event) {
      event.preventDefault();
      this.validate();
      if (this.formErrors.length > 0) return;

      try {
        this.busy = true;
        const response = await this.$service({
          url: `/benh-nhan/create-unfollow-request/${this.benhNhan._id}`,
          method: 'post',
          data: {
            stopFollowReason: this.formModel.stopFollowReason,
            stopFollowReasonDetail: this.formModel.stopFollowReasonDetail,
          },
        });
        if (!response) throw Error('Thất bại');
        this.$swal({
          title: this.$t('success'),
          text: 'Đề xuất ngừng theo dõi bệnh nhân thành công',
          icon: 'success',
          toast: true,
          position: 'top-end',
          timer: 5000,
        });
      } catch (error) {
        this.$swal({
          title: this.$t('error'),
          text: 'Đề xuất ngừng theo dõi bệnh nhân thất bại',
          icon: 'error',
          toast: true,
          position: 'top-end',
          timer: 5000,
        });
      } finally {
        this.busy = false;
        this.visible = false;
        this.$bus.$emit('reloadBenhNhanList');
      }
    },
  },
};
</script>
